export const CERTIFICATE_LABELS = {
  // ─── Page / nav ───────────────────────────────────────────────────────────────
  PAGE_TITLE: 'Certyfikaty',
  TAB_TEMPLATES: 'Szablony',
  TAB_CERTIFICATES: 'Certyfikaty',

  BUTTON_CREATE_TEMPLATE: 'Dodaj szablon certyfikatu',

  LIST_SEARCH_PLACEHOLDER: 'Szukaj po ID szablonu',

  LIST_COL_CREATED_AT: 'Data utworzenia',
  LIST_COL_CERTIFICATE_NAME: 'Nazwa szablonu',
  LIST_COL_TEMPLATE_ID: 'Template ID',
  LIST_COL_TASK_FORM_ID: 'Task Form ID',
  LIST_COL_TASK_FORM_NAME: 'Formularz zadania',
  LIST_COL_ACTIONS: 'Akcje',

  LIST_ACTION_VIEW: 'Podgląd',
  LIST_ACTION_EDIT: 'Edytuj',
  EMPTY_STATE_TITLE: 'Brak dostępnych szablonów certyfikatów.',
  EMPTY_STATE_DESCRIPTION:
    'Skonfiguruj szablony certyfikatów, aby usprawnić proces certyfikacji.',
  NO_RESULTS_TITLE: 'Nie znaleziono wyników.',
  NO_RESULTS_DESCRIPTION_SEARCH: 'Spróbuj zmienić kryteria wyszukiwania.',
  NO_RESULTS_DESCRIPTION_FILTER: 'Spróbuj zmienić zastosowane filtry.',
  NO_RESULTS_DESCRIPTION_BOTH:
    'Spróbuj zmienić kryteria wyszukiwania lub zastosowane filtry.',
  CERTIFICATES_TAB_EMPTY_TITLE: 'Brak dostępnych certyfikatów.',
  CERTIFICATES_TAB_EMPTY_DESCRIPTION:
    'Wystawione certyfikaty pojawią się tutaj.',

  // ─── View page ────────────────────────────────────────────────────────────────
  VIEW_PAGE_TITLE: 'View Certificate Template',
  VIEW_BUTTON_EDIT: 'Edytuj szablon certyfikatu',
  VIEW_DETAILS_TITLE: 'Certificate Template Details',
  VIEW_FIELD_TEMPLATE_ID: 'Template ID',
  VIEW_FIELD_TASK_FORM: 'Formularz zadania',
  VIEW_FIELD_TASK_FORM_ID: 'Task Form ID',
  VIEW_FIELD_CREATED_DATE: 'Data utworzenia',
  VIEW_VALUE_EMPTY: '—',
  VIEW_ERROR_GENERIC: 'Nie udało się załadować szablonu certyfikatu.',

  // ─── Create page ──────────────────────────────────────────────────────────────
  /** EN: "Create certificate template" */
  CREATE_TITLE: 'Utwórz szablon certyfikatu',
  /** EN: "Preview" */
  PREVIEW_TITLE: 'Podgląd',

  // ─── Form fields ─────────────────────────────────────────────────────────────
  /** EN: "Template name" */
  FIELD_TEMPLATE_NAME: 'Nazwa szablonu',
  /** EN: "Select a task form" */
  FIELD_FORM_SELECT: 'Wybierz formularz zadania',
  /** EN: "Certificate data" */
  SECTION_CERTIFICATE_DATA: 'Dane certyfikatu',
  /** EN: "Enter basic identifying information and context to help technicians recognise and understand the purpose of this form." */
  SECTION_CERTIFICATE_DATA_DESC:
    'Podaj podstawowe informacje identyfikacyjne i kontekst, aby pomóc technikom rozpoznać i zrozumieć przeznaczenie tego formularza.',
  /** EN: "Header" */
  FIELD_HEADER: 'Nagłówek',
  /** EN: "Footer text" */
  FIELD_FOOTER: 'Tekst stopki',
  /** EN: "Subtitle (Optional)" */
  FIELD_SUBTITLE: 'Podtytuł (Optional)',

  // ─── Checkboxes ───────────────────────────────────────────────────────────────
  /** EN: "Data will be automatically fetched from service requests" */
  AUTO_DATA_SECTION:
    'Dane zostaną automatycznie pobrane ze zgłoszeń serwisowych',
  /** EN: "Include client, facility and equipment data" */
  CHECK_CLIENT_FACILITY: 'Uwzględnij dane klienta, placówki i aparatury',
  /** EN: "Include service request data" */
  CHECK_SERVICE_REQUEST: 'Uwzględnij dane zgłoszenia serwisowego',
  /** EN: "Include assigned technician data" */
  CHECK_TECHNICIAN: 'Uwzględnij dane przypisanego technika',

  // ─── Field selection ──────────────────────────────────────────────────────────
  /** EN: "Task form fields" */
  SECTION_FORM_FIELDS: 'Pola formularza zadania',
  /** EN: "Select the fields from the form that should be visible in the certificate." */
  SECTION_FORM_FIELDS_DESC:
    'Wybierz pola z formularza, które mają być widoczne w certyfikacie.',
  /** EN: "Select a task form first." */
  FIELD_SELECTION_PLACEHOLDER: 'Najpierw wybierz formularz zadania.',
  /** EN: "This form has no fields." */
  FIELD_SELECTION_NO_FIELDS: 'Ten formularz nie ma pól.',
  // ─── Buttons ──────────────────────────────────────────────────────────────────
  /** EN: "Cancel" */
  BUTTON_CANCEL: 'Anuluj',
  /** EN: "Preview" */
  BUTTON_PREVIEW: 'Podgląd',
  /** EN: "Save" */
  BUTTON_SAVE: 'Zapisz',
  /** EN: "Saving..." */
  BUTTON_SAVING: 'Zapisywanie...',
  /** EN: "Back" (from preview back to edit) */
  BUTTON_BACK: 'Anuluj',

  // ─── Edit page ────────────────────────────────────────────────────────────────
  /** EN: "Edit certificate template" */
  EDIT_TITLE: 'Edytuj szablon certyfikatu',
  /** "Template ID" (disabled field on edit screen) */
  FIELD_TEMPLATE_ID: 'Template ID',
  /** "Task Form ID" (disabled field on edit screen) */
  FIELD_TASK_FORM_ID: 'Task Form ID',

  // ─── Success / error feedback ─────────────────────────────────────────────────
  CREATE_SUCCESS: 'Certificate template added successfully.',
  EDIT_SUCCESS: 'Certificate template updated successfully.',

  // ─── Validation errors ────────────────────────────────────────────────────────
  ERROR_TEMPLATE_NAME_REQUIRED: 'To pole jest wymagane.',
  ERROR_TEMPLATE_NAME_MAX: 'Nazwa szablonu może mieć maksymalnie 200 znaków.',
  ERROR_FORM_REQUIRED: 'To pole jest wymagane.',
  ERROR_HEADER_REQUIRED: 'To pole jest wymagane.',
  ERROR_HEADER_MAX: 'Nagłówek może mieć maksymalnie 200 znaków.',
  ERROR_FOOTER_REQUIRED: 'To pole jest wymagane.',
  ERROR_FOOTER_MAX: 'Tekst stopki może mieć maksymalnie 200 znaków.',
  ERROR_SUBTITLE_MAX: 'Podtytuł może mieć maksymalnie 500 znaków.',
  /** EN: "Select at least one additional field to proceed, apart from the preselected ones." */
  ERROR_FIELDS_REQUIRED:
    'Wybierz co najmniej jedno dodatkowe pole, oprócz wstępnie zaznaczonych, aby kontynuować.',

  // ─── Cancel modal ─────────────────────────────────────────────────────────────
  CANCEL_MODAL_TITLE: 'Czy na pewno chcesz anulować?',
  CANCEL_MODAL_DESC: 'Wszystkie niezapisane dane zostaną utracone.',
  CANCEL_MODAL_CONFIRM: 'Tak, anuluj',
  CANCEL_MODAL_BACK: 'Wróć',
} as const;

export const CERTIFICATE_PREVIEW_LABELS = {
  SUBTITLE_DEFAULT:
    'This is to certify that the service request for the below-mentioned equipment has been successfully completed as per the required standards and guidelines.',
  CLIENT_NAME_PLACEHOLDER: 'SummitCare Medical Solutions (CLIENT0000001)',
  CLIENT_EMAIL_PLACEHOLDER: 'SummitCare@gmail.com',
  CLIENT_PHONE_PLACEHOLDER: '+48 2838839883',
  FACILITY_NAME_PLACEHOLDER: 'SummitCare Outpatient Clinic (FAC0001)',
  FACILITY_ADDRESS_PLACEHOLDER:
    'ul. Marszałkowska 10, Warszawa, Mazowieckie,\n Poland - 00-024',
  DATE_OF_ISSUE_LABEL: 'Date of Issue',
  DATE_OF_ISSUE_PLACEHOLDER: 'YYYY/MM/DD',

  EQUIPMENT_SECTION_TITLE: 'BASIC TEST RESULTS',
  EQUIPMENT_FIELD_NAME: 'Nazwa aparatury',
  EQUIPMENT_FIELD_ID: 'ID aparatury',
  EQUIPMENT_FIELD_MODEL: 'Nazwa modelu',
  EQUIPMENT_FIELD_SERIAL: 'Numer seryjny',
  EQUIPMENT_FIELD_PRODUCTION_DATE: 'Data produkcji',
  EQUIPMENT_FIELD_SERVICE_TYPE: 'Typ usługi',
  EQUIPMENT_VALUE_PLACEHOLDER: (label: string) => `[${label}]`,

  TECHNICIAN_SIGNATURE: "Technician's Signature",
  TECHNICIAN_DETAILS_PLACEHOLDER: 'Jan Kowalski (TECH00000110)',
  CLIENT_SIGNATURE: "Client's Signature",
} as const;
